import Image from "next/image";

import { cn } from "@/lib/utils";

export function Maze({ className }: { className?: string }) {
  return (
    <Image
      src="/company_logos/Maze-black.svg"
      alt="Maze logo"
      width={994}
      height={221}
      className={cn(className, "w-auto brightness-0")}
    />
  );
}
